module.exports = __webpack_public_path__ + "static/img/feature_03.f5d48f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/ares/secondAnniversary/3/feature_03.png
// module id = CYdy
// module chunks = 10